<template>
  <div class="container py-4 py-lg-5 my-lg-5 px-4 px-sm-0">
    <div class="col-sm-12 ml-auto">
      <div class="card p-4 bg-faded">
        <h1 class="text-center fw-400 mb-4 d-xs-block">
          Ustawianie nowego hasła
        </h1>

        <password-form button-text="Ustaw" @setPassword="setPassword" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import PasswordForm from '@/components/forms/PasswordForm';
import { notificationsMixin } from '@/mixins/notifications';
import { authResource } from '@/resources/auth.resource';
import { serverError } from '@/utils/serverError';

// @vuese
// Ustawianie nowego hasła
// @group StartRoute
export default {
  name: 'SetPassword',
  components: {
    PasswordForm
  },
  mixins: [notificationsMixin],
  computed: mapState({ appTitle: state => state.system.appTitle }),
  mounted() {
    document.title = 'Ustawianie nowego hasła' + ' - ' + this.appTitle;
  },
  methods: {
    // @vuese
    // Ustawia nowe hasło
    setPassword(password) {
      authResource
        .setPassword(this.$route.params.token, password)
        .then(() =>
          this.$store.commit('showConfirm', {
            title: 'Ustawiono nowe hasło',
            showCloseButton: false,
            submitButton: 'Ok',
            onSuccess: () => this.$router.push({ name: 'login' })
          })
        )
        .catch(err => this.notifyError(serverError(err)));
    }
  }
};
</script>
